// extracted by mini-css-extract-plugin
module.exports = {"premium-badge":"styles-m__premium-badge__1o3sT"};